module.exports = __webpack_public_path__ + "img/imagination.165c87f5.png";